import type { Logger } from '@connected/api-client/lib/logger.config';

import { setErrorLoggingConfig } from '@connected/api-client';
import { createLogger } from '@connected/api-client/lib/logger';
import { ApiTransport } from '@connected/api-client/lib/logger.api';
import { ConsoleTransport } from '@connected/api-client/lib/logger.console';

declare global {
    // eslint-disable-next-line ts/consistent-type-definitions
    interface Window {
        logger: Logger;
    }
}

export const logger = createLogger({
    name: 'klantenportaal',
    level: import.meta.env.DEV ? 'DEBUG' : 'INFO',
    version: import.meta.env.VITE_APP_VERSION ?? 'unknown',
    transports: [new ConsoleTransport({ level: import.meta.env.DEV ? 'DEBUG' : 'INFO' }), new ApiTransport({ level: import.meta.env.DEV ? 'OFF' : 'ERROR' })],
    metadata: {
        appKind: 'PortalApp',
        apiUrl: import.meta.env.VITE_API_URL,
        appUrl: import.meta.env.VITE_APP_URL,
    },
});

setErrorLoggingConfig({
    appKind: 'PortalApp',
    appUrl: import.meta.env.VITE_APP_URL,
    appVersion: import.meta.env.VITE_APP_VERSION ?? 'unknown',
});

window.logger = logger;
